import { SVGProps } from "react";
const ArrowUndoLongPostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.633 11.68H3.805V8.853"
    />
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.289 15.376a7.97 7.97 0 0 0-2.34-5.527 8 8 0 0 0-11.313 0 8 8 0 0 0-1.366 1.832"
    />
  </svg>
);
export default ArrowUndoLongPostSvg;
